var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("ScoringSurveyAccessLinks", {
        attrs: { viewModel: _vm.scoringSurveyAccessLinks },
        on: {
          "show-email-sender": _vm.handleShowEmailSender,
          "download-links": _vm.handleDownloadAccessLinks,
        },
      }),
      _vm._v(" "),
      _c("ScoringSurveyEmailSender", {
        attrs: { viewModel: _vm.scoringSurveyEmailSender },
        on: { "send-email": _vm.handleSendEmailCommand },
      }),
      _vm._v(" "),
      _c("ScoringPanelistsManager", {
        attrs: { viewModel: _vm.scoringPanelistsManager },
        on: { "include-panelist": _vm.handleIncludeScoringPanelistCommand },
      }),
      _vm._v(" "),
      _c("PanelistConsistencyAnalysisDialog", {
        attrs: {
          propOpened: _vm.panelistConsistencyAnalysisOpened === true,
          propRm: _vm.panelistConsistencyAnalysis,
        },
        on: {
          "close-dialog": function ($event) {
            _vm.panelistConsistencyAnalysisOpened = false
          },
        },
      }),
      _vm._v(" "),
      _c("PortfolioOrDecisionNavigation", {
        attrs: { workspaceId: _vm.workspaceId, projectId: _vm.projectId },
      }),
      _vm._v(" "),
      _vm.Initialized
        ? _c(
            "div",
            {
              staticClass: "container",
              staticStyle: { "margin-top": "80px", "padding-top": "40px" },
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-6" }, [
                  _c("h6", [
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "sanitizedHref",
                            rawName: "v-sanitizedHref",
                            value: _vm.url_ScoringPanelsPage,
                            expression: "url_ScoringPanelsPage",
                          },
                        ],
                        staticClass: "text-dark",
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-angle-double-left",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(" Back to scoring panels\n                    "),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "h1",
                    {
                      staticStyle: {
                        "font-size": "2em",
                        "font-weight": "300",
                        color: "#33475b",
                        margin: "0",
                      },
                    },
                    [
                      _vm._v(
                        "\n                    Panelists: " +
                          _vm._s(_vm.SurveyName) +
                          " "
                      ),
                      _vm.Progress != null
                        ? _c("span", [
                            _vm._v("(" + _vm._s(_vm.Progress) + "%)"),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-lg-6 text-right mt-auto" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary",
                      staticStyle: { padding: "0.7em 2em" },
                      attrs: { role: "button" },
                      on: { click: _vm.DownloadLinksCommand },
                    },
                    [_vm._v("Access links")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success",
                      staticStyle: { padding: "0.7em 2em" },
                      attrs: { role: "button" },
                      on: { click: _vm.AddPanelistsCommand },
                    },
                    [_vm._v("Add panelists")]
                  ),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("hr", {
        staticStyle: { "border-color": "#bbb", margin: "20px 0 60px" },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        !_vm.Initialized
          ? _c("h3", [
              _c("i", { staticClass: "fa fa-spinner fa-spin" }),
              _vm._v(" Loading... "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.Initialized
          ? _c("div", [
              _c(
                "nav",
                {
                  staticClass: "navbar navbar-light navbar-expand-md bg-light",
                  attrs: { role: "navigation" },
                },
                [
                  _c("form", { staticClass: "form-inline mr-2" }, [
                    _c("div", { staticClass: "btn-group" }, [
                      _vm.NonePanelistsSelected
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-secondary btn-sm",
                              attrs: { type: "button" },
                              on: { click: _vm.SelectAllCommand },
                            },
                            [_c("i", { staticClass: "fa-regular fa-square" })]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.AnyPanelistsSelected && !_vm.AllPanelistsSelected
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-secondary btn-sm",
                              attrs: { type: "button" },
                              on: { click: _vm.UnselectAllCommand },
                            },
                            [_c("i", { staticClass: "fa fa-square-minus" })]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.AllPanelistsSelected
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-secondary btn-sm",
                              attrs: { type: "button" },
                              on: { click: _vm.UnselectAllCommand },
                            },
                            [
                              _c("i", {
                                staticClass: "fa-regular fa-square-check",
                              }),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("button", {
                        staticClass:
                          "btn btn-outline-secondary btn-sm dropdown-toggle dropdown-toggle-split",
                        attrs: { type: "button", "data-toggle": "dropdown" },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "dropdown-menu" }, [
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: { click: _vm.SelectAllCommand },
                          },
                          [_vm._v("All")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: { click: _vm.UnselectAllCommand },
                          },
                          [_vm._v("None")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: { click: _vm.InverseSelectionCommand },
                          },
                          [_vm._v("Inverse")]
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("form", { staticClass: "form-inline mr-auto" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm",
                        class: [
                          _vm.NonePanelistsSelected
                            ? "btn-outline-secondary"
                            : "btn-outline-primary",
                        ],
                        attrs: {
                          type: "button",
                          disabled: _vm.NonePanelistsSelected,
                        },
                        on: { click: _vm.EmailManyCommand },
                      },
                      [
                        _vm._v(
                          "\n                        Send email (" +
                            _vm._s(_vm.SelectedPanelistsCount) +
                            ")\n                    "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("form", { staticClass: "form-inline my-2 my-lg-0 mr-2" }, [
                    _c("div", { staticClass: "dropdown" }, [
                      _vm._v("\n                        Filter: "),
                      _c(
                        "a",
                        {
                          staticClass:
                            "text-primary font-weight-bold dropdown-toggle",
                          attrs: { "data-toggle": "dropdown" },
                        },
                        [_vm._v(_vm._s(_vm.FilterLabel))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "dropdown-menu dropdown-menu-right" },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item my-2",
                              on: {
                                click: function ($event) {
                                  return _vm.resetFilters()
                                },
                              },
                            },
                            [_c("span", [_vm._v("All panelists")])]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "dropdown-divider" }),
                          _vm._v(" "),
                          _c("h6", { staticClass: "dropdown-header" }, [
                            _vm._v("By progress:"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item my-2",
                              on: {
                                click: function ($event) {
                                  return _vm.filterByProgress("Not started")
                                },
                              },
                            },
                            [_c("span", [_vm._v("Not started")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item my-2",
                              on: {
                                click: function ($event) {
                                  return _vm.filterByProgress("In progress")
                                },
                              },
                            },
                            [_c("span", [_vm._v("In progress")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item my-2",
                              on: {
                                click: function ($event) {
                                  return _vm.filterByProgress("Completed")
                                },
                              },
                            },
                            [_c("span", [_vm._v("Completed")])]
                          ),
                          _vm._v(" "),
                          _c("h6", { staticClass: "dropdown-header" }, [
                            _vm._v("By tag:"),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.tags, function (t) {
                            return _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.filterByTag(t)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(t))]
                            )
                          }),
                        ],
                        2
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      staticClass: "form-inline my-2 my-lg-0",
                      attrs: { role: "search" },
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.SearchPhrase,
                            expression: "SearchPhrase",
                          },
                        ],
                        staticClass: "form-control form-control-sm mr-sm-2",
                        attrs: { type: "search", placeholder: "Search" },
                        domProps: { value: _vm.SearchPhrase },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.SearchPhrase = $event.target.value
                          },
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col" }, [
                  _c("table", { staticClass: "table table-hover" }, [
                    _c(
                      "tbody",
                      _vm._l(_vm.PanelistsView, function (p) {
                        return _c("tr", { key: p.Id }, [
                          _c(
                            "td",
                            {
                              staticClass: "align-middle",
                              staticStyle: { width: "32px" },
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: p.Selected,
                                    expression: "p.Selected",
                                  },
                                ],
                                staticStyle: { width: "16px", height: "16px" },
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(p.Selected)
                                    ? _vm._i(p.Selected, null) > -1
                                    : p.Selected,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = p.Selected,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            p,
                                            "Selected",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            p,
                                            "Selected",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(p, "Selected", $$c)
                                    }
                                  },
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "p",
                              { staticClass: "fg-color-gray mb-0 mt-1" },
                              [_c("span", [_vm._v(_vm._s(p.Name))])]
                            ),
                            _vm._v(" "),
                            p.HasEmail
                              ? _c("small", { staticClass: "text-muted" }, [
                                  _vm._v(_vm._s(p.Email)),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            !p.HasEmail
                              ? _c("small", { staticClass: "text-danger" }, [
                                  _vm._v("Email not provided"),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass: "align-middle",
                              staticStyle: { width: "150px" },
                            },
                            [
                              !p.IsDeleted
                                ? _c("div", { staticClass: "dropdown" }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "text-primary",
                                        attrs: { "data-toggle": "dropdown" },
                                      },
                                      [
                                        _vm._v(
                                          "Vote strength: " +
                                            _vm._s(p.VoteStrength)
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "dropdown-menu",
                                        attrs: { role: "menu" },
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "dropdown-item",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleChangeCriteriaPanelistVoteStrengthCommand(
                                                  p,
                                                  0
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Vote strength: 0")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass: "dropdown-item",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleChangeCriteriaPanelistVoteStrengthCommand(
                                                  p,
                                                  1
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Vote strength: 1")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass: "dropdown-item",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleChangeCriteriaPanelistVoteStrengthCommand(
                                                  p,
                                                  2
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Vote strength: 2")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass: "dropdown-item",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleChangeCriteriaPanelistVoteStrengthCommand(
                                                  p,
                                                  3
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Vote strength: 3")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass: "dropdown-item",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleChangeCriteriaPanelistVoteStrengthCommand(
                                                  p,
                                                  4
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Vote strength: 4")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass: "dropdown-item",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleChangeCriteriaPanelistVoteStrengthCommand(
                                                  p,
                                                  5
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Vote strength: 5")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass: "dropdown-item",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleChangeCriteriaPanelistVoteStrengthCommand(
                                                  p,
                                                  6
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Vote strength: 6")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass: "dropdown-item",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleChangeCriteriaPanelistVoteStrengthCommand(
                                                  p,
                                                  7
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Vote strength: 7")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass: "dropdown-item",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleChangeCriteriaPanelistVoteStrengthCommand(
                                                  p,
                                                  8
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Vote strength: 8")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass: "dropdown-item",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleChangeCriteriaPanelistVoteStrengthCommand(
                                                  p,
                                                  9
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Vote strength: 9")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass: "dropdown-item",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleChangeCriteriaPanelistVoteStrengthCommand(
                                                  p,
                                                  10
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Vote strength: 10")]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "dropdown-divider",
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass: "dropdown-item",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleExcludePanelistsCommand(
                                                  p
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Exclude")]
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              p.IsDeleted
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "text-primary",
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleExcludePanelistsCommand(
                                            p
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Exclude")]
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass: "align-middle",
                              staticStyle: { width: "120px" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "progress",
                                  staticStyle: { margin: "0" },
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "progress-bar progress-bar-success progress-bar-striped",
                                    style: { width: `${p.Progress}%` },
                                    attrs: {
                                      title: `${p.Progress}%`,
                                      role: "progressbar",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass: "align-middle",
                              staticStyle: { width: "30px" },
                            },
                            [
                              !p.IsDeleted
                                ? _c("ConsistencyAnalysisCircles", {
                                    staticClass: "pointer",
                                    attrs: {
                                      status: p.ConsistencyAnalysisStatus,
                                      size: 1,
                                    },
                                    on: {
                                      "show-consistency-analysis": function (
                                        $event
                                      ) {
                                        return _vm.showPanelistConsistencyAnalysis(
                                          p.Id
                                        )
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass: "align-middle",
                              staticStyle: { width: "120px" },
                            },
                            [
                              _c("div", { staticClass: "dropdown" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-outline-secondary dropdown-toggle",
                                    attrs: {
                                      type: "button",
                                      "data-toggle": "dropdown",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                            Actions\n                                        "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "dropdown-menu dropdown-menu-right",
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        directives: [
                                          {
                                            name: "sanitizedHref",
                                            rawName: "v-sanitizedHref",
                                            value: `/#/scoring/dashboard/${_vm.workspaceId}/${_vm.surveyId}/${p.Id}`,
                                            expression:
                                              "`/#/scoring/dashboard/${workspaceId}/${surveyId}/${p.Id}`",
                                          },
                                        ],
                                        staticClass: "dropdown-item",
                                        attrs: { target: "_blank" },
                                      },
                                      [_vm._v("Review")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "dropdown-item",
                                        on: {
                                          click: function ($event) {
                                            return _vm.EmailOneCommand(p)
                                          },
                                        },
                                      },
                                      [_vm._v("Email")]
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "dropdown-divider",
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "dropdown-item",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleExcludePanelistsCommand(
                                              p
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Exclude")]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ])
                      }),
                      0
                    ),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }